import ValueX from '../types/ValueX';

export default class DetailX extends ValueX {
    static __className = 'DetailX';

    constructor(constructJson) {
        super(constructJson, 'detail', 'DetailX');
    }
}
